export function capitalizeFirstCharForRequestState(str: string) {  
  if (!str) return ''; // Vérifie si la chaîne est vide ou nulle
  if (str === "EN_ATTENTE") {
    return "En attente";
  }
  else if (str === "ACCEPTEE") {
    return "Acceptée"
  }
  else if (str === "REFUSEE") {
    return "Refusée"
  }
  else if (str === "EFFECTUEE") {
    return "Effectuée"
  }
  else {
    return null;
  }
}

export function capitalizeFirstChar(strLowerCase: string) {
  if (!strLowerCase) return ''; // Vérifie si la chaîne est vide ou nulle
  return strLowerCase.charAt(0).toUpperCase() + strLowerCase.slice(1);
}